//# sourceMappingURL=font-types.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/pdfmake-wrapper/lib/interfaces/fonts/font-types.interface.js
// module id = 1169
// module chunks = 4